<script>
    export default {
        props: ['id'],
        data() {
            return {
                show : true,
            }
        },
        methods: {
            close() {
                this.show = false;
                axios.post('/flash-messages/'+ this.id +'/close')
            }
        },
        mounted() {
            //
        }
    }
</script>
